import { messageModule } from '@/api'
import { ResWrap, service } from '@/utils/request'

export enum MsgTabEnum {
  All = 'all',
  Black = 'black',
  Zalo = 'ZALO',
  Telegram='TELEGRAM',
  Twitter='TWITTER',
  Messager='MESSAGER',
  WhatsApp='WHATSAPP',
  Line="LINE",
  Rcs="RCS"
}
export const MsgTabList = [
  {
    name: 'CHAT.msg_tab_all',
    value: MsgTabEnum.All
  },
  {
    name: 'Zalo',
    value: MsgTabEnum.Zalo
  },
  {
    name: 'Telegram',
    value: MsgTabEnum.Telegram
  },
  {
    name: 'Twitter',
    value: MsgTabEnum.Twitter
  },
  {
    name: 'Messager',
    value: MsgTabEnum.Messager
  },
  {
    name: 'WhatsApp',
    value: MsgTabEnum.WhatsApp
  },
  {
    name: 'Line',
    value: MsgTabEnum.Line
  },{
    name: 'Rcs',
    value: MsgTabEnum.Rcs
  }
]
/**
 * MessageSendRequest
 */
export interface IMessageSendParam {
  /**
   * 消息类型
   */
  messageType?: MessageType
  /**
   * 消息内容
   */
  msg?: string
  /**
   * 富文本s3的key
   */
  recordFileKeys?: RecordFileKey[]
  /**
   * 聊天会话ID
   */
  sessionId?: string

  tmpId?:string
}

/**
 * 消息类型
 */
export enum MessageType {
  Audio = 'AUDIO',
  Emoji = 'EMOJI',
  File = 'FILE',
  Image = 'IMAGE',
  MergeMsg = 'MERGE_MSG',
  RichText = 'RICH_TEXT',
  Text = 'TEXT',
  Tip = 'TIP',
  Video = 'VIDEO',
  Loading = 'LOADING',
  Voice = 'VOICE',
  Order = 'ORDER',
}

/**
 * 消息关联文件key
 *
 * RecordFileKey
 */
export interface RecordFileKey {
  /**
   * 文件key
   */
  fileKey?: string
  /**
   * 文件url
   */
  fileUrl?: string
  /**
   * 关联的json内容
   */
  value?: string
}

/**
 * MessageUserWithdrawRequest
 */
export interface IMessageUserWithdrawRequest {
  /**
   * 消息记录ID
   */
  recordId?: number
  /**
   * 聊天会话ID
   */
  sessionId?: number
  /**
   * 用户ID
   */
  userId?: number
}

/**
 * 用户发送信息
 *
 * @param param
 */
export function sendMessage(param: IMessageSendParam): Promise<ResWrap<null>> {
  return service.post(`${messageModule.sendMessageApi}`, param)
}

/**
 * 撤回消息
 * @param param
 */
export function widthDrawMessage(param: IMessageUserWithdrawRequest): Promise<ResWrap<null>> {
  return service.post(`${messageModule.withdrawApi}`, param)
}

export function rcsSendAll(param: any): Promise<ResWrap<null>> {
  return service.post(`${messageModule.rcsSendAllApi}`, param)
}
/**
 * 账号详情
 *
 * @param param
 */
export function rcsSendList(param: any): Promise<ResWrap<null>> {
  return service.post(`${messageModule.rcsSendListApi}`, param)
}

/**
 * 打开会话
 *
 * @param param
 */
export function thirdSessionDetail(param: any): Promise<ResWrap<null>> {
  return service.post(`${messageModule.thirdSessionDetailApi}`, param)
}
